import { useEffect, useState } from "react";
import { getAllEvents } from "./getAllEventMasterDetails";
import { parseCapacity } from "./capacityLimits";

export const useEventCapacity = (eventId) => {
  const [eventRecord, setEventRecord] = useState(null);

  useEffect(() => {
    let cancelled = false;
    if (!eventId) {
      setEventRecord(null);
      return undefined;
    }
    getAllEvents()
      .then((list) => {
        if (cancelled) return;
        const match = (list || []).find(
          (item) => String(item._id) === String(eventId)
        );
        setEventRecord(match || null);
      })
      .catch(() => {
        if (!cancelled) setEventRecord(null);
      });
    return () => {
      cancelled = true;
    };
  }, [eventId]);

  return {
    eventRecord,
    eventCapacityLabel: eventRecord?.capacity || "",
    eventCapacity: parseCapacity(eventRecord?.capacity),
  };
};
